import React, { useState } from 'react';
import Swal from 'sweetalert2';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card'
import { FaCheck, FaRegUserCircle, FaStore  } from 'react-icons/fa';

function StorageApp() {
    const [privateKey, setPrivateKey] = useState('');
    const [contractAddress, setContractAddress] = useState('');
    const [setValueInput, setSetValueInput] = useState('');
    const [transactionHash, setTransactionHash] = useState('');
    const [storedValue, setStoredValue] = useState('');

    const deployContract = async() =>{
        try{
            if(privateKey){
                const response=await fetch('http://localhost:4000/deploy-contract',{
                    method:'POST',
                    headers:{
                    'Content-Type':'application/json',
                    },
                    body:JSON.stringify({privateKey}),
                });
            
            
                if(response.ok){
                    const data=await response.json();
                    setContractAddress(data.address);
                    Swal.fire("BERJAYA!!", `Alamat Berjaya Dihubungi<br />Alamat : ${data.address}`, "success");
                }else{
                    console.error('Deployment failed');
                    Swal.fire("RALAT!!", "Pembangunan Gagal", "error");
                }
            }else{
                console.error('Privatekey is required for deployment.');
                Swal.fire("RALAT!!", "Pembangunan . Tiada PrivateKey", "error");
            }
        }catch(error){
            console.error('Error during deployment:',error);
            Swal.fire("RALAT!!", "Pembangunan Gagal", "error");
        }
    };

    const deployValue = async() => {
        try{
            if(setValueInput){
                Swal.fire({
                    title: "Waiting for response from server!",
                    html: "please wait!<br>",
                    allowOutsideClick: false,
                    didOpen: () => {
                      Swal.showLoading();
                    },
                });
                const response = await fetch('http://localhost:4000/call-contract', {
                    method: 'POST',
                    headers: {
                        'Content-Type' : 'application/json',
                    },
                    body: JSON.stringify({ privateKey, contractAddress, entity: setValueInput}),
                });

                if(response.ok){
                    const data = await response.json();
                    setTransactionHash(data);
                    Swal.close();
                    Swal.fire("BERJAYA!!",`Transaksi Data : ${data}`, "success");
                } else {
                    Swal.close();
                    Swal.fire("RALAT!!", "Kesilapan sistem", "error");
                    console.error("error");
                }
            } else {
                Swal.fire("RALAT!!", "Kesilapan sistem", "error");
                console.error('Data Diperlukan')
            }
        } catch(error){
            Swal.fire("RALAT!!", "Kesilapan sistem", "error");
            console.log(error);
        }
    }

    const getValue = async() => {
        try {
            if (contractAddress) {
                const response = await fetch(`http://localhost:4000/get-contract?contractAddress=${contractAddress}`);

                if (response.ok) {
                    const data = await response.json();
                    const result = data.result;
                    setStoredValue(result);
                    Swal.fire("BERJAYA!!", "Data terakhir berjaya didapati", "success");
                } else {
                    Swal.fire("RALAT!!", "Kesilapan sistem", "error");
                    console.error('Getting value failed');
                }
            } else {
                Swal.fire("RALAT!!", "Kesilapan sistem", "error");
                console.error('Contract address is required to get the value.');
            }
        } catch (error) {
            Swal.fire("RALAT!!", "Kesilapan sistem", "error");
            console.error('Error while getting value:', error);
        }
    }


    return (
        <>
        <h1>Simple Storage DApp</h1>
            <Card border='success'>
                <Card.Header style={{ backgroundColor:'blue', color:'white' }}>
                    <h2 style={{textAlign:'center'}}>Deploy Contract</h2>
                </Card.Header>
                <Card.Body>
                    <div>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="basic-addon1">
                            Private Key
                            </InputGroup.Text>
                            <Form.Control id="privateKey" aria-describedby="basic-addon1" value={privateKey} onChange={(e)=>setPrivateKey(e.target.value)}  />
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="basic-addon2">
                            Address
                            </InputGroup.Text>
                            <Form.Control id="contractAddress" aria-describedby="basic-addon2" value={contractAddress} />
                        </InputGroup>
                        <div style={{textAlign:'right'}}>
                            <Button variant='primary' size='lg' onClick={deployContract}><FaRegUserCircle /> Deploy Contract</Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
                
            <Card border='danger'>
                <Card.Header style={{ backgroundColor:'maroon', color:'yellow' }}>
                    <h2 style={{textAlign:'center'}}>Call Contract</h2>
                </Card.Header>
                <Card.Body>
                    <div>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="basic-addon3">
                            Value Input
                            </InputGroup.Text>
                            <Form.Control id="setValueInput" aria-describedby="basic-addon3" value={setValueInput} onChange={(e)=>setSetValueInput(e.target.value)}  />
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="basic-addon4">
                            Transaction Hash
                            </InputGroup.Text>
                            <Form.Control id="transactionHash" aria-describedby="basic-addon4" value={transactionHash} onChange={(e)=>setTransactionHash(e.target.value)} />
                        </InputGroup>
                        <div style={{textAlign:'right'}}>
                            <Button variant='secondary' size='lg' onClick={deployValue}><FaStore /> Set Value</Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card border='primary'>
                <Card.Header style={{ backgroundColor:'#033E3E', color:'white' }}>
                    <h2 style={{textAlign:'center'}}>Get Latest Value</h2>
                </Card.Header>
                <Card.Body>
                    <div className="d-grid gap-2">
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="basic-addon5">
                            Get Value
                            </InputGroup.Text>
                            <Form.Control id="storedValue" aria-describedby="basic-addon5" value={storedValue} onChange={(e)=>setStoredValue(e.target.value)}  />
                        </InputGroup>
                        <div style={{textAlign:'right'}}>
                            <Button variant='info' size='lg' onClick={getValue}><FaCheck /> Get Value</Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
}


export default StorageApp;